import * as React from 'react'
import { PlannedMaintenance as PlannedMaintenancePattern } from '@tumelo/designsystem'

export const PlannedMaintenance = () => {
  return (
    <PlannedMaintenancePattern
      heading="Planned maintenance: we are currently performing scheduled maintenance. We will be back as soon as possible."
      logoSrc="/images/tumelo_logo_white.png"
    />
  )
}
